var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1 .5h21v21H1z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.625 4.875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#008CFF",
    strokeWidth: 1.5,
    d: "M4.375 0h7c.966 0 1.75.784 1.75 1.75V14h0-10.5V1.75c0-.966.784-1.75 1.75-1.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7,
    r: 1,
    fill: "#008CFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A90E2",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M.838 14.039H14.97"
  })))));
}
export default SvgRoom;